// The same bundle is deployed to every slot, so nothing at build time knows
// which slot it ends up being served from - the hostname is the only thing that
// tells them apart at runtime. The alpha slot is served straight off the apex
// domain, so there is no leading label to key off and the hostname has to be
// matched whole. Anything not listed here - a customer's own host, a local dev
// server - falls through to the plain title in index.html.
//
// Alpha is the slot that stays open all day, so it keeps the plain product
// name; beta is the one that has to stand out next to it. Giving alpha its own
// prefix later is a one-word change here.
const SLOT_TITLE_PREFIXES: Record<string, string> = {
  '2404.ch': '',      // alpha
  'beta.2404.ch': 'Beta',
};

// Under `yarn dev` the address bar says localhost, but every API call is proxied
// to PROXY_TARGET - so the slot on screen is the proxy's, not localhost's, and
// that is the one the title has to name. Vite replaces __DEV_PROXY_HOST__ with
// the proxy hostname at build time; the branch drops out of a production build.
function currentHost(): string {
  return import.meta.env.DEV
           ? __DEV_PROXY_HOST__
           : window.location.hostname;
}

export function slotTitlePrefix(hostname: string = currentHost()): string {
  const host = hostname.toLowerCase().replace(/^www\./, '');
  return SLOT_TITLE_PREFIXES[host] ?? '';
}

// Prefixes the document title with the slot name, so an operator with a beta
// tab and an alpha tab side by side can tell them apart. index.html stays the
// single place the product name is spelled out - we only prepend to it.
export function applySlotToTitle(): void {
  const prefix = slotTitlePrefix();

  if (prefix)
    document.title = `${prefix} ${document.title}`;
}
